import React from 'react';
import '../marketing.css';

const ClubGuide = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'white',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '30px',
          paddingBottom: '20px',
          borderBottom: '3px solid #dc2626'
        }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_volunteer-hub-35/artifacts/5ta1s578_playback%20logo.jpg" 
            alt="PlayBack Token Logo" 
            style={{
              width: '60px',
              height: '60px',
              margin: '0 auto 15px',
              display: 'block'
            }}
          />
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: '800',
            color: '#dc2626',
            marginBottom: '8px',
            letterSpacing: '-0.5px'
          }}>
            PlayBack Token
          </h1>
          <p style={{
            fontSize: '1.25rem',
            color: '#6b7280',
            fontWeight: '600'
          }}>
            Turn Volunteer Time into Real Value
          </p>
        </div>
        
        {/* Introduction */}
        <div style={{
          background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
          padding: '25px',
          borderRadius: '12px',
          marginBottom: '30px',
          borderLeft: '4px solid #dc2626'
        }}>
          <p style={{
            fontSize: '1rem',
            color: '#374151',
            lineHeight: '1.7',
            marginBottom: '15px'
          }}>
            <strong>Dear Club Administrator,</strong>
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#374151',
            lineHeight: '1.7',
            marginBottom: '0'
          }}>
            Your volunteers contribute countless hours to your community. What if that time could generate real funding for your club? PlayBack Token helps sports clubs and community organizations turn volunteer hours into money—<strong>at no cost to you!</strong>
          </p>
        </div>
        
        {/* What We Do */}
        <div style={{ marginBottom: '30px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#dc2626',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span style={{ fontSize: '1.75rem' }}>💡</span> What We Do
          </h2>
          <p style={{
            fontSize: '1rem',
            color: '#4b5563',
            lineHeight: '1.7'
          }}>
            We help clubs track and verify volunteer hours using a simple mobile app. These verified hours are then purchased by large corporations looking to support community organizations. The money goes directly to your club's bank account!
          </p>
        </div>
        
        {/* Key Benefits */}
        <div style={{ marginBottom: '30px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#dc2626',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span style={{ fontSize: '1.75rem' }}>✨</span> Why Join PlayBack Token?
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '15px',
            marginBottom: '30px'
          }}>
            <div style={{
              background: '#f9fafb',
              padding: '20px',
              borderRadius: '10px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{
                fontWeight: '700',
                color: '#dc2626',
                marginBottom: '8px',
                fontSize: '1rem'
              }}>
                💰 Generate Revenue
              </div>
              <div style={{
                fontSize: '0.95rem',
                color: '#4b5563',
                lineHeight: '1.5'
              }}>
                Turn volunteer hours into real funding from corporations
              </div>
            </div>
            
            <div style={{
              background: '#f9fafb',
              padding: '20px',
              borderRadius: '10px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{
                fontWeight: '700',
                color: '#dc2626',
                marginBottom: '8px',
                fontSize: '1rem'
              }}>
                🆓 Completely Free
              </div>
              <div style={{
                fontSize: '0.95rem',
                color: '#4b5563',
                lineHeight: '1.5'
              }}>
                No setup fees, no monthly costs, no hidden charges—ever!
              </div>
            </div>
            
            <div style={{
              background: '#f9fafb',
              padding: '20px',
              borderRadius: '10px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{
                fontWeight: '700',
                color: '#dc2626',
                marginBottom: '8px',
                fontSize: '1rem'
              }}>
                📱 Simple to Use
              </div>
              <div style={{
                fontSize: '0.95rem',
                color: '#4b5563',
                lineHeight: '1.5'
              }}>
                Easy mobile app for volunteers to log their time
              </div>
            </div>
            
            <div style={{
              background: '#f9fafb',
              padding: '20px',
              borderRadius: '10px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{
                fontWeight: '700',
                color: '#dc2626',
                marginBottom: '8px',
                fontSize: '1rem'
              }}>
                ✅ 100% Transparent
              </div>
              <div style={{
                fontSize: '0.95rem',
                color: '#4b5563',
                lineHeight: '1.5'
              }}>
                See exactly what you earn from every hour logged
              </div>
            </div>
          </div>
        </div>
        
        {/* How It Works */}
        <div style={{ marginBottom: '30px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#dc2626',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span style={{ fontSize: '1.75rem' }}>🔄</span> How It Works (3 Simple Steps)
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '15px',
            marginBottom: '30px'
          }}>
            <div style={{
              background: 'white',
              border: '2px solid #dc2626',
              borderRadius: '12px',
              padding: '20px',
              textAlign: 'center'
            }}>
              <div style={{
                width: '45px',
                height: '45px',
                background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                color: 'white',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '800',
                fontSize: '1.5rem',
                margin: '0 auto 15px'
              }}>
                1
              </div>
              <div style={{
                fontSize: '0.95rem',
                fontWeight: '600',
                color: '#1f2937',
                lineHeight: '1.4'
              }}>
                Volunteers log their hours using our mobile app
              </div>
            </div>
            
            <div style={{
              background: 'white',
              border: '2px solid #dc2626',
              borderRadius: '12px',
              padding: '20px',
              textAlign: 'center'
            }}>
              <div style={{
                width: '45px',
                height: '45px',
                background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                color: 'white',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '800',
                fontSize: '1.5rem',
                margin: '0 auto 15px'
              }}>
                2
              </div>
              <div style={{
                fontSize: '0.95rem',
                fontWeight: '600',
                color: '#1f2937',
                lineHeight: '1.4'
              }}>
                You approve the hours they've worked
              </div>
            </div>
            
            <div style={{
              background: 'white',
              border: '2px solid #dc2626',
              borderRadius: '12px',
              padding: '20px',
              textAlign: 'center'
            }}>
              <div style={{
                width: '45px',
                height: '45px',
                background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                color: 'white',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '800',
                fontSize: '1.5rem',
                margin: '0 auto 15px'
              }}>
                3
              </div>
              <div style={{
                fontSize: '0.95rem',
                fontWeight: '600',
                color: '#1f2937',
                lineHeight: '1.4'
              }}>
                We sell the hours to corporations & pay you directly
              </div>
            </div>
          </div>
        </div>
        
        {/* Image Section */}
        <div style={{ textAlign: 'center', margin: '30px 0' }}>
          <img 
            src="https://images.unsplash.com/photo-1691256676376-357c3aa66c89?w=400" 
            alt="Mobile App" 
            style={{
              maxWidth: '250px',
              height: 'auto',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
          />
        </div>
        
        {/* Requirements */}
        <div style={{
          background: '#fffbeb',
          border: '2px solid #fbbf24',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '30px'
        }}>
          <h3 style={{
            fontSize: '1.25rem',
            fontWeight: '700',
            color: '#92400e',
            marginBottom: '10px'
          }}>
            📋 Who Can Join?
          </h3>
          <ul style={{
            marginLeft: '25px',
            marginTop: '12px'
          }}>
            <li style={{
              fontSize: '0.95rem',
              color: '#78350f',
              marginBottom: '8px',
              lineHeight: '1.5'
            }}>
              <strong>Amateur clubs and organizations only</strong> (not professional sports teams)
            </li>
            <li style={{
              fontSize: '0.95rem',
              color: '#78350f',
              marginBottom: '8px',
              lineHeight: '1.5'
            }}>
              <strong>Non-paid volunteers</strong> (coaches, administrators, maintenance staff, etc.)
            </li>
            <li style={{
              fontSize: '0.95rem',
              color: '#78350f',
              marginBottom: '0',
              lineHeight: '1.5'
            }}>
              <strong>Registered organization</strong> with a bank account
            </li>
          </ul>
        </div>
        
        {/* Call to Action */}
        <div style={{
          background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
          color: 'white',
          padding: '30px',
          borderRadius: '12px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          <div style={{
            fontSize: '1.75rem',
            fontWeight: '800',
            marginBottom: '12px'
          }}>
            Ready to Get Started?
          </div>
          <div style={{
            fontSize: '1.1rem',
            marginBottom: '20px',
            opacity: '0.95'
          }}>
            Email us today to request an application form!
          </div>
          <a 
            href="mailto:info@playbacktoken.com" 
            style={{
              background: 'white',
              color: '#dc2626',
              padding: '15px 35px',
              borderRadius: '8px',
              fontWeight: '700',
              fontSize: '1.1rem',
              display: 'inline-block',
              textDecoration: 'none',
              transition: 'transform 0.2s',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          >
            📧 info@playbacktoken.com
          </a>
        </div>
        
        {/* Footer */}
        <div style={{
          textAlign: 'center',
          fontSize: '0.85rem',
          color: '#9ca3af',
          marginTop: '20px',
          paddingTop: '20px',
          borderTop: '1px solid #e5e7eb'
        }}>
          <p style={{ marginBottom: '8px' }}>
            <strong>PlayBack Token</strong> | www.playbacktoken.com
          </p>
          <p style={{ margin: '0' }}>
            Terms and conditions apply. We'll review your application and get back to you within 5 business days.
          </p>
        </div>
        
        {/* Share Instructions */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '30px',
          padding: '20px',
          background: '#f9fafb',
          borderRadius: '10px',
          border: '1px solid #e5e7eb'
        }}>
          <p style={{
            fontSize: '0.95rem',
            color: '#4b5563',
            marginBottom: '10px',
            fontWeight: '600'
          }}>
            📱 Share this page via WhatsApp:
          </p>
          <p style={{
            fontSize: '0.85rem',
            color: '#6b7280',
            fontFamily: 'monospace',
            background: 'white',
            padding: '10px',
            borderRadius: '6px',
            border: '1px solid #d1d5db',
            wordBreak: 'break-all'
          }}>
            https://playbacktoken.com/club-guide
          </p>
          <p style={{
            fontSize: '0.8rem',
            color: '#9ca3af',
            marginTop: '10px',
            marginBottom: '0'
          }}>
            Copy and paste this link to share with clubs
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClubGuide;
